import Papa from 'papaparse';

// Prevents CSV/formula injection: a cell value starting with one of these
// characters can be interpreted as a formula by Excel/Sheets when the file
// is opened. Prefixing with a single quote neutralizes it while leaving the
// visible text unchanged. Several of our export sources (e.g. third-party
// device/vendor fields) are not user-controlled by us, so this is applied
// to every export rather than trusted per-caller.
const FORMULA_INJECTION_PREFIXES = ['=', '+', '-', '@', '\t', '\r'];

const sanitizeCsvValue = (value: string | undefined): string | undefined => {
  if (typeof value !== 'string') return value;
  return FORMULA_INJECTION_PREFIXES.some(prefix => value.startsWith(prefix))
    ? `'${value}`
    : value;
};

export const exportCSV = (
  csvData: Array<Record<string, string | undefined>>,
  fileName: string
) => {
  const sanitizedData = csvData.map(row =>
    Object.fromEntries(
      Object.entries(row).map(([key, value]) => [key, sanitizeCsvValue(value)])
    )
  );
  const csvFile = new Blob(['﻿' + Papa.unparse(sanitizedData)], {
    type: 'text/csv;charset=utf-8',
  });
  const downloadLink = document.createElement('a');
  downloadLink.href = URL.createObjectURL(csvFile);
  downloadLink.download = fileName;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};
